import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const TopBar = styled.img`
  width: 50px;
`;

export const TitleTxt = styled.div`
  font-size: 49.2px;
  font-weight: bold;
  color: #971a35;
  padding-left: 20px;
`;

export const BodyTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 50px;
  gap: 20px;
`;

export const SubTitleTxt = styled.div`
  font-size: 24.6px;
  font-weight: bold;
  color: #971a35;
`;

export const TextBlock = styled.div`
  font-size: 15px;
  color: black;
`;
